import { registerBlockType } from "@wordpress/blocks";
import config from "./block.json";
import { InnerBlocks } from "@wordpress/block-editor";
import LeitungInfoEditor from "./LeitungInfoEditor";

registerBlockType(config.name, {
  ...config,
  edit: LeitungInfoEditor,
  save() {
    return <InnerBlocks.Content />;
  },
});
